import React from 'react'
import { CollapsibleSection } from '../UI/CollapsibleSection/CollapsibleSection'
import { CreateDoorProxyModal } from '../Modals/CompanyModal/CreateDoorProxyModal'
import { UnmatchedDoorsTable } from '../DataExpansionComponents/UnmatchedDoors/UnmatchedDoorsTable'
import { IContactCompany } from 'models/contact_companies'
import { FilterIdentifier } from 'models/saved_view'
import { UnmatchedOnlyDoorSectionProps } from './DoorSections/types'

export function UnmatchedOnlyDoorSection({
  forChainProxyId,
  chainData,
  subCategory,
  unmatchedTableKeyPrefix,
}: UnmatchedOnlyDoorSectionProps) {
  // Create chainProxy object for CreateDoorProxyModal
  const chainProxy: IContactCompany | undefined =
    chainData && subCategory
      ? ({
          id: forChainProxyId,
          domain: chainData.domain || '',
          name: chainData.name || subCategory.name,
          sub_category: subCategory,
        } as IContactCompany)
      : undefined

  const unmatchedTableKey = `${unmatchedTableKeyPrefix}-${forChainProxyId}`

  return (
    <CollapsibleSection
      summary={
        <div className="flex flex-row justify-between items-center w-full">
          <div className="flex flex-row items-center space-x-4">
            <span>Doors</span>
          </div>
          <div className="flex flex-row items-center space-x-2">
            {chainProxy && (
              <CreateDoorProxyModal
                chainProxy={chainProxy}
                unmatchedTableKey={unmatchedTableKey}
              />
            )}
          </div>
        </div>
      }
    >
      <div className="w-full">
        <div className="max-h-[600px] flex pb-1 pt-4 w-full">
          {chainProxy && (
            <UnmatchedDoorsTable
              tableKey={unmatchedTableKey}
              filterIdentifierModifier={
                forChainProxyId.toString() as FilterIdentifier
              }
              chainProxy={chainProxy}
            />
          )}
        </div>
      </div>
    </CollapsibleSection>
  )
}
